import type { ReactNode } from "react";
import { StyleSheet, View, type ViewProps } from "react-native";

import { Radius } from "~/constants/sizing";
import { useTheme } from "~/providers/ThemeProvider";

type DataListProps = {
    children: ReactNode;
} & Omit<ViewProps, "children">;

export const DataList = ({ children, ...viewProps }: DataListProps) => {
    const { background } = useTheme();
    return (
        <View {...viewProps} style={[styles.container, background.primary, viewProps.style]}>
            {children}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        borderRadius: Radius.lg,
    },
});
